import { CUSTOM_DOMAINS_STATUSES } from 'constants/sllr';
import { isDashboardArabic } from 'utils/intl-wrapper';
import { getSllrLink } from 'utils/sllr-store';

export const getPageFullURL = ({ businessInfo, pageURL }) =>
  `${getSllrLink(businessInfo)}${
    businessInfo?.storeInfo?.domainStatus === CUSTOM_DOMAINS_STATUSES.CONNECTED
      ? ''
      : '/'
  }${pageURL}`;

export const getPageName = ({ pageTitle, pageTitleAr }) => {
  return isDashboardArabic()
    ? pageTitleAr || pageTitle
    : pageTitle || pageTitleAr;
};

export const visitPage = (props) => window.open(getPageFullURL(props));
